import(/* webpackMode: "eager" */ "/app/apps/marketing/src/app/[brand]/error.tsx");
